export default "__VITE_ASSET__DsHGGIL8__"